var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/facebook.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 126.6 126.6\" class=\"c-social__facebook\" aria-labelledby=\"facebook-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"facebook-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-facebook"])), env.opts.autoescape);
output += "\n    </title>\n   <path class=\"c-footer-social__path\" id=\"Facebook__x28_alt_x29_\" class=\"st0\" d=\"M126.6 21.1c0-11.1-10-21.1-21.1-21.1H21.1C10 0 0 10 0 21.1v84.4c0 11.1 10 21.1 21.1 21.1h42.2V78.8H47.8V57.7h15.5v-8.2c0-14.2 10.6-26.9 23.7-26.9h17.1v21.1H87c-1.9 0-4 2.3-4 5.7v8.4h21.1v21.1H83v47.8h22.5c11.1 0 21.1-10 21.1-21.1V21.1z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/facebook.j2"] , dependencies)